import React from 'react';

import { PlusOutlined } from '@ant-design/icons';
import { Button as AntdButton } from 'antd';

import { useModal } from 'hooks/modal/useModal';

import ModalCreate from '../Modals/ModalCreate';
import { FilterDashboardMotifSortie } from '../types';

import { Filter } from './Filter/Filter';

interface DashboardHeaderProps {
  totalCount: number;
  filter: Partial<FilterDashboardMotifSortie>;
  setFilter: (value: Partial<FilterDashboardMotifSortie>) => void;
}

function DashboardHeader({
  totalCount,
  filter,
  setFilter,
}: DashboardHeaderProps): React.ReactElement {
  const countString = `${totalCount} motif${totalCount > 1 ? 's' : ''} trouvé${
    totalCount > 1 ? 's' : ''
  }`;

  const modalCreation = useModal();

  const refreshDashboard = () => {
    setFilter({ ...filter });
  };

  return (
    <div>
      <div className="dashboard-header-fields header-referentiels">
        <Filter filter={filter} setFilter={setFilter} />
        <AntdButton
          icon={<PlusOutlined />}
          type="primary"
          shape="round"
          onClick={modalCreation.open}
        >
          Créer un motif de sortie
        </AntdButton>
        <ModalCreate
          visible={modalCreation.visible}
          close={modalCreation.close}
          refreshDashboard={refreshDashboard}
        />
      </div>
      <p>{countString}</p>
    </div>
  );
}

export default DashboardHeader;
